export const meetingsRBDMSchema = {
	title: 'RBDM meeting schema',
	description: 'RBDM Meeting Schema',
	version: 0,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 100,
		},
		type: {
			type: ['string', 'null'],
		},
		name: {
			type: ['string', 'null'],
		},
		status: {
			type: ['string', 'null'],
		},
		startdate: {
			type: ['string', 'null'],
		},
		enddate: {
			type: ['string', 'null'],
		},
		start_time_c: {
			type: ['string', 'null'],
		},
		end_time_c: {
			type: ['string', 'null'],
		},
		meeting_theme_c: {
			type: ['string', 'null'],
		},
		meeting_venue_c: {
			type: ['string', 'null'],
		},
		club_name_c: {
			type: ['string', 'null'],
		},
		club_name_id_c: {
			type: ['string', 'null'],
		},
		mdicode_c: {
			type: ['string', 'null'],
		},
		assigned_cmdi_c: {
			type: ['string', 'null'],
		},
		latitude_against_town: {
			type: ['number', 'null'],
		},
		longitude_against_town: {
			type: ['number', 'null'],
		},
		meeting_latitude_c: {
			type: ['number', 'null'],
		},
		meeting_longitude_c: {
			type: ['number', 'null'],
		},
		meeting_type_c: {
			type: ['string', 'null'],
		},
		focus_product_1: {
			type: ['string', 'null'],
		},
		focus_product_2: {
			type: ['string', 'null'],
		},
		focus_product_4: {
			type: ['string', 'null'],
		},
		focus_product_5: {
			type: ['string', 'null'],
		},
		town_venue_c: {
			type: ['string', 'null'],
		},
		meetformatid_c: {
			type: ['integer', 'null'],
		},
		app_id_c: {
			type: ['string', 'null'],
		},
		mdi_name_c: {
			type: ['string', 'null'],
		},
	},
	required: ['id'],
};
